import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const schema = () =>
  yup.object().shape({
    corporateUser: yup
      .object()
      .nullable()
      .required(getEmptyErrorMessage(t('labelQuoteContact'))),
  });
